import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MobileNavPartsComponent } from './mobile-nav-parts.component';
import { DrawerModule } from '../drawer/drawer.module';
import { SearchModule } from '../search/search.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    SearchModule,
    FormsModule
  ],
  declarations: [
    MobileNavPartsComponent
  ],
  exports: [
    MobileNavPartsComponent
  ]
})
export class MobileNavPartsModule { }
